module.exports = __webpack_public_path__ + "img/phone.3c882808.png";